import { useState, useEffect } from 'react';

const slides = [
  'https://montebrisa.com/wp-content/uploads/slider/cache/ab0400c0e86957f1435b6d2b12b2db38/inicio_1.jpg',
  'https://montebrisa.com/wp-content/uploads/slider/cache/0fdddf710b88a92306d11c22ab80cf33/inicio_2.jpg',
  'https://montebrisa.com/wp-content/uploads/slider/cache/b5773ffd52886314ba4f3c2f2bd72c84/inicio_4.jpg',
  'https://montebrisa.com/wp-content/uploads/slider/cache/c26d1ba1bfc58668f7e671b39c23e18d/inicio_6.jpg',
  'https://montebrisa.com/wp-content/uploads/slider/cache/e87b5ead4f4e91b27730d30118f0cf46/top-bosque.jpg',
  'https://montebrisa.com/wp-content/uploads/slider/cache/5947e46b126b8090d9dd6a8131d9c143/top-cafe.jpg',
];

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setCurrent(c => (c + 1) % slides.length), 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative w-full h-screen min-h-[640px] flex items-center justify-center overflow-hidden">
      {/* Slideshow */}
      {slides.map((src, idx) => (
        <div
          key={src}
          className="absolute inset-0 w-full h-full transition-opacity duration-1000"
          style={{ opacity: idx === current ? 1 : 0 }}
        >
          <img src={src} alt="Montebrisa" className="w-full h-full object-cover object-center" />
        </div>
      ))}

      {/* Overlays */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/65" />

      {/* Confidential banner */}
      <div className="absolute top-24 left-0 right-0 flex justify-center z-10">
        <div className="bg-gold/90 text-white font-sans text-xs tracking-[0.25em] uppercase px-6 py-1.5 rounded-full">
          Confidential Investment Opportunity · Not for Public Distribution
        </div>
      </div>

      {/* Hero Content */}
      <div className="relative z-10 flex flex-col items-center text-center px-4 w-full animate-fade-in">
        <div className="flex items-center gap-4 mb-6">
          <div className="w-16 h-px bg-gold/70" />
          <span className="text-gold/90 text-xs font-sans tracking-[0.3em] uppercase">Property For Sale · Matagalpa, Nicaragua</span>
          <div className="w-16 h-px bg-gold/70" />
        </div>

        <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl text-white font-normal leading-tight mb-4 drop-shadow-md">
          A Turnkey 1940s Art Déco<br />Boutique B&amp;B
        </h1>

        <p className="font-sans text-lg md:text-xl text-white/85 font-light tracking-wide mb-10 max-w-2xl">
          Fully operational · Award-winning · Lush tropical gardens · Prime urban location
        </p>

        <div className="flex flex-col sm:flex-row gap-4">
          <button
            onClick={() => document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' })}
            className="px-8 py-3 bg-gold text-white font-sans text-sm tracking-widest uppercase rounded-md hover:bg-gold-dark transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            View the Property
          </button>
          <button
            onClick={() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="px-8 py-3 border border-white/80 text-white font-sans text-sm tracking-widest uppercase rounded-md hover:bg-white hover:text-forest transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Request Information
          </button>
        </div>

        <div className="mt-10 flex items-center gap-3 bg-black/30 backdrop-blur-sm border border-gold/30 rounded-full px-5 py-2">
          <i className="ri-award-line text-gold text-lg w-5 h-5 flex items-center justify-center" />
          <span className="text-white/90 text-xs font-sans tracking-wider">TripAdvisor 2019 Travelers&apos; Choice · Top 1% Worldwide · #1 B&amp;B in Matagalpa</span>
        </div>
      </div>

      {/* Slide dots */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex gap-2">
        {slides.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrent(idx)}
            className={`rounded-full transition-all duration-300 cursor-pointer ${idx === current ? 'w-6 h-2 bg-gold' : 'w-2 h-2 bg-white/40 hover:bg-white/70'}`}
            aria-label={`Slide ${idx + 1}`}
          />
        ))}
      </div>
    </section>
  );
}
